import React, {memo} from "react";

import useOrg from "Hooks/useOrg";

/**
 * `withOrg` HOC wrapper
 *
 * Makes the active state organisation object available on a component as `org`.
 *
 * The value of the `org` prop will be `null` when we've no registration!
 *
 * @package HOPS
 * @subpackage Hoc
 * @copyright Heritage Operations Processing Limited
 */
const withOrg = Component => {
	return memo(props => {
		const {getOrgUploadPath, org, orgLogoSrc} = useOrg();
		return <Component
			{...props}
			getOrgUploadPath={getOrgUploadPath}
			org={org}
			orgLogoSrc={orgLogoSrc} />;
	});
};

export default withOrg;

